// extracted by mini-css-extract-plugin
export var modules__media = "modules-module--modules__media--cNqrr";
export var modules__gradient = "modules-module--modules__gradient--VvIWr";
export var modules__content = "modules-module--modules__content--Hpp5H";
export var modules__description = "modules-module--modules__description--53IK2";
export var modules__termsTitle = "modules-module--modules__terms-title--dEvtW";
export var modules__term = "modules-module--modules__term--bacJh";
export var modules__term_support = "modules-module--modules__term_support--SPnpq";
export var modules__term_outsource = "modules-module--modules__term_outsource---cvij";
export var modules__term_customer = "modules-module--modules__term_customer--fYPmr";